import { useLocation, withRouter } from "react-router";
import React, { useContext, useEffect, useRef, useState } from 'react';
import AppNav from "./AppNav";
import 'react-toastify/dist/ReactToastify.css';
import { deleteAPI, downloadAPI, getAPI, patchAPI, postAPI, putAPI } from "../APIUtil";
import Button from "react-bootstrap/Button";
import { Card, Col, Container, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker"
import {
  faCalendar,
  faFileDownload,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import {
  checkKey,
  dateformatDB,
  formatNumber,
  lpad,
  nvl,
  parseDate,
  toNull,
  onFocusText,
  dateformatDatePicker,
  toSingleByteNumberOnly,
  nextStatusByApprove,
  dispPayGrpStatus,
  startLoadingBtn,
  addField,
  finishLoadingBtn,
  amountFormatter,
  CONST_TAX_EXP_08,
  CONST_TAX_INC_08,
  CONST_TAX_EXEMPT,
  CONST_TAX_NON_TAX,
  CONST_TAX_EXP_10,
  CONST_TAX_INC_10,
  onKeyDownNext,
  sleepByPromise,
  dateformatYYYY_MM_DD,
  focusById,
  onKeyDownShortCut, rpad
} from "../CMUtil";
import AsyncSelect from "react-select/async";
import { Link, useHistory } from "react-router-dom";
import Toast, { error, success } from "../Toast";
import { PayGrpList } from "./common/PayGrpList";
import { ExpDtlLine } from "./ExpDtlLine";
import { GlobalContext } from "../Global";
import { ApproveList } from "./common/ApproveList";
import { PayDateDialog } from "./common/PayDate";
import { RoutePaths } from "./PageRoutesAuthenticated";

export const ExpDtl = ({ match: { params: { exp_id } } }) => {

  const history = useHistory();

  const { loginUser, setLoginUser } = useContext(GlobalContext);

  const [accList, setAccList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [remarkList, setRemarkList] = useState([]);
  const [deptList, setDeptList] = useState([]);
  const [itemList, setItemList] = useState([]);

  const [sysConsumptionTaxCl, setSysConsumptionTaxCl] = useState("");
  const [sysRoundingOffCl, setSysRoundingOffCl] = useState("");

  const [selectMenuOpen, setSelectMenuOpen] = useState(false);

  // //支払ヘッダ
  const [expId, setExpId] = useState("");
  const [expDateIsOpen, setExpDateIsOpen] = useState(false);
  const [payDate, setPayDate] = useState("");
  const [payDateIsOpen, setPayDateIsOpen] = useState(false);
  const [payGrpType, setPayGrpType] = useState("経費");
  const [payGrpNum, setPayGrpNum] = useState("");
  const [expDate, setExpDate] = useState("");
  const [payGrpStatus, setPayGrpStatus] = useState("");
  const [taxRate, setTaxRate] = useState((10).toFixed(2));

  //内訳
  const [lineList, setLineList] = useState([]);
  const lineListRef = useRef([]);
  const ini = useRef(true);
  const iniPayDate = useRef(true);
  const iniCalcTotal = useRef(true);
  const iniPayGrpNum = useRef(true);

  const [status, setStatus] = useState("");

  const [authorSelected, setAuthorSelected] = useState(null);
  const [authorCd, setAuthorCd] = useState("");
  const [pennameNm, setPennameNm] = useState("");
  const [authorPennameNm, setAuthorPennameNm] = useState("");
  const [authorTel, setAuthorTel] = useState("");
  const [authorCellPhoneNo, setAuthorCellPhoneNo] = useState("");
  const [authorAddr, setAuthorAddr] = useState("");
  const [authorAddrSend, setAuthorAddrSend] = useState("");
  const [authorTelSend, setAuthorTelSend] = useState("");
  const [emailAddressAuthor, setEmailAddressAuthor] = useState("");
  const [bankAccountNm, setBankAccountNm] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [dutyFreeFG, setDutyFreeFG] = useState("");
  const [authorTekikakuNo, setAuthorTekikakuNo] = useState("");

  const [commorancyCl, setCommorancyCl] = useState("");
  const [consumptionTax, setConsumptionTax] = useState("");
  const [roundingOffCl, setRoundingOffCl] = useState("");
  const [withholdingObjectCl, setWithholdingObjectCl] = useState("");

  const [subAmount, setSubAmount] = useState(0);
  const [subAmount08, setSubAmount08] = useState(0);
  const [subAmount10, setSubAmount10] = useState(0);
  const [subAmountExempt, setSubAmountExempt] = useState(0);
  const [subAmountNonTax, setSubAmountNonTax] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [taxAmount08, setTaxAmount08] = useState(0);
  const [taxAmount10, setTaxAmount10] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [withholdTaxAmount, setWithholdTaxAmount] = useState(0);
  const [payAmount, setPayAmount] = useState(0);

  // 基準日ダイアログ
  const [modalPayDateShow, setModalPayDateShow] = useState(false);
  const [modalPayDateMonth, setModalPayDateMonth] = useState("");
  const [modalPayDateList, setModalPayDateList] = useState([]);

  const [dispCount, setDispCount] = useState(1);

  // 支払ステータスダイアログ
  const [payGrpModalShow, setPayGrpModalShow] = useState(false);

  // 承認ダイアログ
  const [appModalShow, setAppModalShow] = useState(false);

  // 確認ダイアログ
  const [confirmModalShow, setConfirmModalShow] = useState(false);

  const asyncSelectStyles = {
    option: (base, { data }) => ({
      ...base,
      whiteSpace: "pre-wrap",
      fontWeight: data.isHeader ? "bold" : base.fontWeight,
      color: data.isHeader ? "black" : base.color,
    }),
    singleValue: (base, { data }) => ({
      ...base,
      whiteSpace: "pre-wrap",
      fontWeight: data.isHeader ? "bold" : base.fontWeight,
      color: data.isHeader ? "black" : base.color,
    }),
  };

  // ショートカットキー：Ctl＋Enter
  const onKeyDownCtlEnter = async (e) => {
    if (!isBtnPaySaveDisabled) {
      e.preventDefault();
      await onClickPaySave();
    }
  }

  // ショートカットキー：Escape
  const onKeyDownEsc = async (e) => {
    if (e.target && e.target.id === "expDate") {
      e.preventDefault();
      history.push(RoutePaths.root.exp_list);　//前画面に戻る
    } else {
      e.preventDefault();
      await focusById("expDate");
    }
  }

  // ショートカットキー：Space
  const onKeyDownSpace = async (e) => {
    if (e && e.target && e.target.getAttribute("author_cd")) {
      //編集ダイアログ
      e.preventDefault();
      await onClickShowModal(e.target.getAttribute("author_cd"));
    }
    if (e && e.target && e.target.id === "btn-pay-add") {
      //新規ダイアログ
      e.preventDefault();
      await onClickShowModal();
    }
  }

  // ショートカットキー：Enter
  const onKeyDownEnter = async (e) => {
    await onKeyDownNext(e);
  }

  // カレンダー用 ////////////////////////////////////////////////////////////////////////////////////////
  const [openCalExpDate, setOpenCalExpDate] = useState(false);
  const handleChangeCalExpDate = async (dateObj) => {
    setExpDate(dateformatYYYY_MM_DD(dateObj))
    setOpenCalExpDate(false);
    await focusById("expDate");
  };

  const [openCalPayDate, setOpenCalPayDate] = useState(false);
  const handleChangeCalPayDate = async (dateObj) => {
    setPayDate(dateformatYYYY_MM_DD(dateObj))
    setOpenCalPayDate(false);
    await focusById("payDate");
  };

  // HOOKイベント ///////////////////////////////////////////////////////////////////////////
  useEffect(() => {

    const update = async () => {
      setExpId(exp_id);
    }
    update();

  }, []);

  useEffect(() => {

    if (ini.current) {
      ini.current = false;
      return;
    }

    const update = async () => {
      let cSysConsumptionTaxCl = 0;
      let cSysRoundingOffCl = 0;
      let cPayDate = "";
      let cPayGrpNum = "";
      let cExpDate = "";
      let cStatus = "";
      let cAuthorCd = "";
      let cPennameNm = "";
      let cAuthorTel = "";
      let cAuthorCellPhoneNo = "";
      let cAuthorAddr = "";
      let cAuthorAddrSend = "";
      let cAuthorTelSend = "";
      let cEmailAddressAuthor = "";
      let cBankAccountNm = "";
      let cBankAccount = "";
      let cDutyFreeFG = "";
      let cAuthorTekikakuNo = "";
      let cCommorancyCl = "";
      let cConsumptionTax = "";
      let cRoundingOffCl = "";
      let cWithholdingObjectCl = "";
      let cLineList = [];
      let cSubAmount = 0;
      let cSubAmount08 = 0;
      let cSubAmount10 = 0;
      let cSubAmountExempt = 0;
      let cSubAmountNonTax = 0;
      let cTaxAmount = 0;
      let cTaxAmount08 = 0;
      let cTaxAmount10 = 0;
      let cTotalAmount = 0;
      let cWithholdTaxAmount = 0;
      let cPayAmount = 0;

      let searchCondition = {};
      let res = null;
      let obj = {};

      // 印税システム管理マスタ
      searchCondition = {
        pay_date: dateformatDB(payDate)
      }
      res = await getAPI("ms_royalty", searchCondition);
      if (res.count > 0) {
        cSysConsumptionTaxCl = nvl(res.results[0].consumption_tax_cl);
        cSysRoundingOffCl = nvl(res.results[0].rounding_off_cl);
      }

      //　支払情報
      if (!expId) {
        cExpDate = dateformatDB(new Date());
      } else {
        obj = await getAPI("tr_exp/" + expId);
        cPayDate = obj.pay_date;
        cPayGrpNum = nvl(obj.pay_grp_num);
        cExpDate = obj.exp_date;
        cStatus = nvl(obj.status);
        cSubAmount = nvl(obj.sub_amount, 0);
        cSubAmount08 = nvl(obj.sub_amount_08, 0);
        cSubAmount10 = nvl(obj.sub_amount_10, 0);
        cSubAmountExempt = nvl(obj.sub_amount_exempt, 0);
        cSubAmountNonTax = nvl(obj.sub_amount_non_tax, 0);
        cTaxAmount = nvl(obj.tax_amount, 0);
        cTaxAmount08 = nvl(obj.tax_amount_08, 0);
        cTaxAmount10 = nvl(obj.tax_amount_10, 0);
        cTotalAmount = nvl(obj.total_amount, 0);
        cWithholdTaxAmount = nvl(obj.withholding_tax_amount, 0);
        cPayAmount = nvl(obj.pay_amount, 0);

        cAuthorCd = nvl(obj.author_cd);
        if (cAuthorCd) {
          obj = await getAPI("ms_author/" + cAuthorCd);
          if (obj) {
            setAuthorCd(obj.author_cd);
            const res = await getAPI("ms_author_search_view", { customer_cd: obj.author_cd });
            const authObj = res.results[0];
            setAuthorSelected({
              option:
                nvl(obj.author_cd) + "　" + nvl(authObj.customer_nm),
              // + (nvl(authObj.penname_nm).trim() ? " ／ " : "") + nvl(authObj.penname_nm),
              id: obj.author_cd,
              name:
                nvl(obj.author_cd) + "　" + nvl(authObj.customer_nm),
              // + (nvl(authObj.penname_nm).trim() ? " ／ " : "") + nvl(authObj.penname_nm),
            });
            cAuthorCd = nvl(obj.author_cd);
            cPennameNm = nvl(obj.penname_nm);
            cAuthorTel = nvl(obj.author_tel);
            cAuthorCellPhoneNo = nvl(obj.author_cell_phone_no);
            cAuthorAddr = nvl(obj.author_zipcode) + " " + nvl(obj.author_address_1) + nvl(obj.author_address_2) + nvl(obj.author_address_3);
            cAuthorAddrSend = nvl(obj.zipcode_send1) + " " + nvl(obj.address1_send1) + nvl(obj.address1_send2) + nvl(obj.address1_send3);
            cAuthorTelSend = nvl(obj.tel_send1);
            cEmailAddressAuthor = nvl(obj.email_address_author);
            cDutyFreeFG = nvl(obj.duty_free);
            cAuthorTekikakuNo = nvl(obj.author_tekikaku_no);

            // 口座情報セット
            cBankAccountNm = nvl(obj.bank_account_nm);
            searchCondition = {
              bank_cd: obj.bank_cd,
              bank_branch_cd: obj.bank_branch_cd
            }
            let oBank = await getAPI("ms_bank", searchCondition);
            if (oBank.count === 1) {
              let o = oBank.results[0];
              cBankAccount = "";
              cBankAccount += nvl(o.bank_nm);
              cBankAccount += "(" + nvl(o.bank_cd) + ")";
              cBankAccount += "　";
              cBankAccount += nvl(o.bank_branch_nm);
              cBankAccount += "(" + nvl(o.bank_branch_cd) + ")";
              cBankAccount += "　";
              if (obj.kind_of_account_cl === "0") {
                cBankAccount += "普通";
              } else if (obj.kind_of_account_cd === "1") {
                cBankAccount += "当座";
              } else if (obj.kind_of_account_cd === "9") {
                cBankAccount += "総合";
              }
              cBankAccount += "　";
              cBankAccount += nvl(obj.bank_account_no);
            }

            cCommorancyCl = nvl(obj.commorancy_cl);
            cConsumptionTax = obj.consumption_tax === 0 ? cSysConsumptionTaxCl : nvl(obj.consumption_tax);
            cRoundingOffCl = obj.rounding_off_cl === 0 ? cSysRoundingOffCl : nvl(obj.rounding_off_cl);
            cWithholdingObjectCl = nvl(obj.withholding_object_cl);
          }
        }

        //内訳
        searchCondition = {
          exp_id: expId
        }
        res = await getAPI("tr_exp_dtl_list_search_view", searchCondition);
        cLineList = res.results;
      }
      while (cLineList.length <= 5) {
        cLineList.push({
          index: cLineList.length,
          exp_id: toNull(expId),
          exp_dtl_id: null,
          expense_cl: null,
          dept_cd: null,
          line_tax_type_cd: null,
          line_amount: null,
          line_tax_amount: null,
          line_total_amount: null,
          line_withhold_tax_amount: null,
          line_pay_amount: null,
          item_cd: null,
          cost_cd: null,
          remark_cd: null,
          note: null
        });
      }

      setSysConsumptionTaxCl(cSysConsumptionTaxCl);
      setSysRoundingOffCl(cSysRoundingOffCl);
      setPayDate(cPayDate);
      setPayGrpNum(cPayGrpNum);
      setExpDate(cExpDate);
      setStatus(cStatus);
      setAuthorCd(cAuthorCd);
      setPennameNm(cPennameNm);
      setAuthorTel(cAuthorTel);
      setAuthorCellPhoneNo(cAuthorCellPhoneNo);
      setAuthorAddr(cAuthorAddr);
      setAuthorAddrSend(cAuthorAddrSend);
      setAuthorTelSend(cAuthorTelSend);
      setEmailAddressAuthor(cEmailAddressAuthor);
      setDutyFreeFG(cDutyFreeFG);
      setAuthorTekikakuNo(cAuthorTekikakuNo);
      setBankAccountNm(cBankAccountNm);
      setBankAccount(cBankAccount);
      setCommorancyCl(cCommorancyCl);
      setConsumptionTax(cConsumptionTax);
      setRoundingOffCl(cRoundingOffCl);
      setSubAmount(cSubAmount);
      setSubAmount08(cSubAmount08);
      setSubAmount10(cSubAmount10);
      setSubAmountExempt(cSubAmountExempt);
      setSubAmountNonTax(cSubAmountNonTax);
      setTaxAmount(cTaxAmount);
      setTaxAmount08(cTaxAmount08);
      setTaxAmount10(cTaxAmount10);
      setTotalAmount(cTotalAmount);
      setWithholdTaxAmount(cWithholdTaxAmount);
      setPayAmount(cPayAmount);
      setWithholdingObjectCl(cWithholdingObjectCl);


      // 科目リスト
      searchCondition = { search_value: "" };
      res = await getAPI("ms_acc1_typeahead_view", searchCondition);
      const cAccList = [];
      for (const obj of res.results) {
        cAccList.push({
          name: lpad(nvl(obj.acc_cd), 3, "0") + " " + nvl(obj.acc_nm),
          id: obj.acc_cd
        });
      }
      setAccList(cAccList);

      // 摘要リスト
      searchCondition = { remark_nm: "" };
      res = await getAPI("ms_remark_typeahead_view", searchCondition);
      const cRemarkList = [];
      for (const obj of res.results) {
        cRemarkList.push({
          name: nvl(obj.remark_cd) + " " + nvl(obj.remark_nm),
          id: obj.remark_cd,
          remark_nm: nvl(obj.remark_nm)
        });
      }
      setRemarkList(cRemarkList);

      // カテゴリリスト
      searchCondition = { expense_cl_nm: "" };
      res = await getAPI("ms_expense_typeahead_view", searchCondition);
      const cExpenseList = [];
      for (const obj of res.results) {
        cExpenseList.push({
          name: lpad(nvl(obj.expense_cl), 2, "0") + " " + nvl(obj.expense_cl_nm),
          id: obj.expense_cl
        });
      }
      setExpenseList(cExpenseList);

      // 部門リスト
      searchCondition = { search_value: "" };
      res = await getAPI("ms_dept_typeahead_view", searchCondition);
      const cDeptList = [];
      for (const obj of res.results) {
        cDeptList.push({
          name: nvl(obj.dept_cd) + " " + nvl(obj.dept_nm),
          id: obj.dept_cd,
          dept_nm: nvl(obj.dept_nm)
        });
      }
      setDeptList(cDeptList);

      // 商品リスト
      searchCondition = { search_value: "" };
      res = await getAPI("ms_item_typeahead_view", searchCondition);
      const cItemList = [];
      for (const obj of res.results) {
        cDeptList.push({
          name: nvl(obj.item_cd) + " " + nvl(obj.item_name),
          id: obj.item_cd,
          dept_nm: nvl(obj.item_name)
        });
      }
      setItemList(cItemList);

      lineListRef.current = [];
      for (let i = 0; i < cLineList.length; i++) {
        lineListRef.current[i] = React.createRef();
      }
      setLineList(cLineList);

      await sleepByPromise(0.02);
      $("#expDate").select();
    }

    update();

  }, [expId, dispCount]);

  useEffect(() => {

    if (iniPayDate.current) {
      iniPayDate.current = false;
      return;
    }

    const update = async () => {

      let cPayGrpStatus = "";
      if (!payDate) {
        setPayGrpStatus(cPayGrpStatus);
        return;
      }

      let searchCondition = {};
      // グループセット
      searchCondition = {
        pay_grp_type: "経費",
        pay_date: dateformatDB(payDate),
        selected: true
      }
      let res = await getAPI("ms_pay_grp", searchCondition);
      if (res.count >= 1) {
        // 選択中グループがある場合
        // 新規作成時のみ Gno を自動セット（修正時は手入力のみ変更可）
        if (!expId) {
          setPayGrpNum(res.results[0].pay_grp_num);
        }
        cPayGrpStatus = dispPayGrpStatus(res.results[0]);

      } else {
        // 選択中グループがない場合
        // 新規作成時のみ Gno を自動セット（修正時は手入力のみ変更可）
        if (!expId) {
          searchCondition = {
            pay_grp_type: "経費",
            pay_date: toNull(dateformatDB(payDate)),
            sort_field: "pay_grp_num",
            sort_order: "desc"
          }
          res = await getAPI("ms_pay_grp", searchCondition);
          if (res.count >= 1) {
            setPayGrpNum(res.results[0].pay_grp_num + 1);
          } else {
            setPayGrpNum(1);
          }
        }
        cPayGrpStatus = "新規";
      }
      setPayGrpStatus(cPayGrpStatus);
    }

    update();

  }, [payDate]);

  useEffect(() => {
    if (iniPayGrpNum.current) {
      iniPayGrpNum.current = false;
      return;
    }
    const update = async () => {
      let cPayGrpStatus = "";
      if (payGrpNum) {
        // グループセット
        cPayGrpStatus = "新規";
        let searchCondition = {
          pay_grp_type: payGrpType,
          pay_date: dateformatDB(parseDate(payDate)),
          pay_grp_num: payGrpNum
        }
        let res = await getAPI("ms_pay_grp_search_view", searchCondition);
        if (res.count === 1) {
          let obj = res.results[0];
          cPayGrpStatus = dispPayGrpStatus(obj);
        }
      }
      setPayGrpStatus(cPayGrpStatus);
    }

    update();

  }, [payGrpNum]);

  // 内訳画面 ////////////////////////////////////////////////////////////////////////////////////
  const setFixedTaxRate = (val) => {
    let cTaxRate = 0;
    if (val) {
      cTaxRate = parseFloat(val);
    }
    setTaxRate(cTaxRate.toFixed(2));

    lineListRef.current.map(lineList => {
      if (lineList.current.getStates().expense_cl == null) {
        return undefined;
      }
      lineList.current.setLineTaxRate(cTaxRate.toFixed(2));
    });
  }

  const onClickExpSave = async () => {

    // 入力チェック
    if (!expDate) {
      error("処理日を入力してください");
      return
    }
    if (!payDate) {
      error("支払日を入力してください");
      return
    }
    if (!payGrpNum) {
      error("Gnoを入力してください");
      return
    }
    if (!authorCd) {
      error("支払先を入力してください");
      return
    }

    let obj = {};
    let cExpId = expId;
    // グループ作成
    if (payDate) {
      let searchCondition = {
        pay_grp_type: payGrpType,
        pay_date: dateformatDB(parseDate(payDate)),
        pay_grp_num: payGrpNum
      }
      let res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (res.count === 0) {
        // グループ追加
        obj = {
          pay_grp_type: payGrpType,
          pay_date: dateformatDB(parseDate(payDate)),
          pay_grp_num: payGrpNum,
          status: "支払前",
          selected: true
        }
        obj = await postAPI("ms_pay_grp/", obj);
        setPayGrpStatus(dispPayGrpStatus(obj));
      }

      // 選択中を解除
      searchCondition = {
        pay_grp_type: payGrpType,
        selected: true
      }
      res = await getAPI("ms_pay_grp_search_view", searchCondition);
      for (let payGrp of res.results) {
        if (payGrp.pay_grp_type === payGrpType && payGrp.pay_date === dateformatDB(parseDate(payDate)) && payGrp.pay_grp_num === payGrpNum) {
          //今回利用分はスキップ
          continue;
        }
        payGrp.selected = false;
        payGrp = await putAPI("ms_pay_grp/" + payGrp.pay_grp_id + "/", payGrp);
      }

      // 選択中にする
      searchCondition = {
        pay_grp_type: payGrpType,
        pay_date: dateformatDB(parseDate(payDate)),
        pay_grp_num: payGrpNum
      }
      res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (!res.results[0].selected) {
        let cPayGrp = res.results[0];
        cPayGrp.selected = true;
        cPayGrp = await putAPI("ms_pay_grp/" + cPayGrp.pay_grp_id + "/", cPayGrp);
      }
    }

    obj = {};
    if (!cExpId) {
      //新規登録
      obj.pay_date = toNull(payDate);
      obj.pay_grp_type = toNull(payGrpType);
      obj.pay_grp_num = toNull(payGrpNum);
      obj.exp_date = toNull(expDate);
      obj.status = '支払前';
      obj.tax_rate = toNull(taxRate);
      obj.author_cd = toNull(authorCd);
      obj.sub_amount = toNull(subAmount);
      obj.sub_amount_08 = toNull(subAmount08);
      obj.sub_amount_10 = toNull(subAmount10);
      obj.sub_amount_exempt = toNull(subAmountExempt);
      obj.sub_amount_non_tax = toNull(subAmountNonTax);
      obj.tax_amount = toNull(taxAmount);
      obj.tax_amount_08 = toNull(taxAmount08);
      obj.tax_amount_10 = toNull(taxAmount10);
      obj.total_amount = toNull(totalAmount);
      obj.withholding_tax_amount = toNull(withholdTaxAmount);
      obj.pay_amount = toNull(payAmount);
      obj = await postAPI("tr_exp/", obj);
      cExpId = obj.exp_id;
    } else {
      //更新
      obj.pay_date = toNull(payDate);
      obj.pay_grp_type = toNull(payGrpType);
      obj.pay_grp_num = toNull(payGrpNum);
      obj.exp_date = toNull(expDate);
      obj.status = '支払前';
      obj.tax_rate = toNull(taxRate);
      obj.author_cd = toNull(authorCd);
      obj.sub_amount = toNull(subAmount);
      obj.sub_amount_08 = toNull(subAmount08);
      obj.sub_amount_10 = toNull(subAmount10);
      obj.sub_amount_exempt = toNull(subAmountExempt);
      obj.sub_amount_non_tax = toNull(subAmountNonTax);
      obj.tax_amount = toNull(taxAmount);
      obj.tax_amount_08 = toNull(taxAmount08);
      obj.tax_amount_10 = toNull(taxAmount10);
      obj.total_amount = toNull(totalAmount);
      obj.withholding_tax_amount = toNull(withholdTaxAmount);
      obj.pay_amount = toNull(payAmount);
      obj = await patchAPI("tr_exp/" + cExpId + "/", obj);
    }

    let cLineList = [];
    lineListRef.current.map(lineList => {
      cLineList.push(lineList.current.getStates());
    });
    cLineList = await lineBulkSave(cExpId, cLineList);

    // 採番済みの明細IDを各行に反映（2回目以降の保存で再登録されないようにする）
    cLineList.forEach(savedLine => {
      const lineRef = lineListRef.current[savedLine.line_no - 1];
      if (lineRef && lineRef.current) {
        lineRef.current.setSavedIds(savedLine.exp_id, savedLine.exp_dtl_id);
      }
    });

    history.push("/exp_dtl/" + cExpId + "/");
    setExpId(cExpId);
    // setDispCount(dispCount + 1);
    success("保存しました");
  }

  const lineBulkSave = async (cExpId, cLineList) => {

    let updatedLineList = [];
    for (let i = 0; i < cLineList.length; i++) {
      let cLine = cLineList[i];
      let obj = {};
      if (!cLine.exp_dtl_id) {
        obj.exp_id = cExpId;
        obj.line_no = i + 1;
        obj.acc_cd = toNull(cLine.acc_cd);
        obj.acc_suffix_cd = toNull(cLine.acc_suffix_cd);
        obj.expense_cl = toNull(cLine.expense_cl);
        obj.item_cd = toNull(cLine.item_cd);
        obj.dept_cd = toNull(cLine.dept_cd);
        obj.line_tax_class_cd = toNull(cLine.line_tax_class_cd)
        obj.line_amount = toNull(cLine.line_amount);
        obj.line_tax_amount = toNull(cLine.line_tax_amount);
        obj.line_total_amount = toNull(cLine.line_total_amount);
        obj.line_withhold_tax_amount = toNull(cLine.line_withhold_tax_amount);
        obj.line_pay_amount = toNull(cLine.line_pay_amount);
        obj.cost_cd = toNull(cLine.cost_cd);
        obj.remark_cd = toNull(cLine.remark_cd);
        obj.note = toNull(cLine.note);
        if (!cLine.expense_cl && !obj.dept_cd && !obj.line_tax_type_cd && !obj.line_tax_rate && !obj.line_amount && !obj.line_tax_amount && !obj.line_total_amount &&
          !obj.line_withhold_tax_amount && !obj.line_pay_amount && !obj.item_cd && !obj.cost_cd && !obj.remark_cd && !obj.note) {
          //スキップ
          continue;
        }
        //明細追加
        obj = await postAPI("tr_exp_dtl/", obj);
      } else {
        //更新
        obj = await getAPI("tr_exp_dtl/" + cLine.exp_dtl_id);
        obj.exp_id = cExpId;
        obj.line_no = i + 1;
        obj.acc_cd = toNull(cLine.acc_cd);
        obj.acc_suffix_cd = toNull(cLine.acc_suffix_cd);
        obj.expense_cl = toNull(cLine.expense_cl);
        obj.item_cd = toNull(cLine.item_cd);
        obj.dept_cd = toNull(cLine.dept_cd);
        obj.line_tax_class_cd = toNull(cLine.line_tax_class_cd)
        obj.line_amount = toNull(cLine.line_amount);
        obj.line_tax_amount = toNull(cLine.line_tax_amount);
        obj.line_total_amount = toNull(cLine.line_total_amount);
        obj.line_withhold_tax_amount = toNull(cLine.line_withhold_tax_amount);
        obj.line_pay_amount = toNull(cLine.line_pay_amount);
        obj.cost_cd = toNull(cLine.cost_cd);
        obj.remark_cd = toNull(cLine.remark_cd);
        obj.note = toNull(cLine.note);
        obj = await putAPI("tr_exp_dtl/" + cLine.exp_dtl_id + "/", obj);
      }
      updatedLineList.push(obj);
    }
    return updatedLineList;
  }

  const onFocusAcc = (index) => {
    appendLine();
    if (index > 0
      && lineListRef.current[index] && lineListRef.current[index].current
      && lineListRef.current[index - 1] && lineListRef.current[index - 1].current) {
      if (lineListRef.current[index].current.isEmpty()) {
        const prevValues = lineListRef.current[index - 1].current.getSelectedValues();
        if (prevValues.accCd) {
          lineListRef.current[index].current.copyFromPrev(prevValues);
        }
      }
    }
  }

  const appendLine = async () => {
    let emptyLineCnt = 0;
    lineListRef.current.map(lineList => {
      if (lineList.current.isEmpty()) {
        emptyLineCnt += 1;
      }
    });

    if (emptyLineCnt < 1) {
      let cLineList = lineList;
      cLineList = JSON.parse(JSON.stringify(cLineList));
      cLineList.push({
        index: cLineList.length,
        exp_id: toNull(expId),
        exp_dtl_id: null,
        expense_cl: null,
        dept_cd: null,
        line_tax_type_cd: null,
        line_amount: null,
        line_tax_amount: null,
        line_total_amount: null,
        line_withhold_tax_amount: null,
        line_pay_amount: null,
        item_cd: null,
        cost_cd: null,
        remark_cd: null,
        note: null
      });
      lineListRef.current[lineListRef.current.length] = React.createRef();
      setLineList(cLineList);
    }
  }

  const handleChangeAuthor = async (value) => {
    if (!value) {
      setAuthorSelected(null);
      setAuthorCd("");
      return;
    }
    let searchCondition = null;
    setAuthorSelected({
      name: value.name,
      id: value.id,
      option: value.name
    });

    setAuthorCd(value.id);

    let cAuthorCd = value.id;
    let cPennameNm = "";
    let cAuthorTel = "";
    let cAuthorCellPhoneNo = "";
    let cAuthorAddr = "";
    let cAuthorAddrSend = "";
    let cAuthorTelSend = "";
    let cEmailAddressAuthor = "";
    let cBankAccountNm = "";
    let cBankAccount = "";
    let cCommorancyCl = "";
    let cConsumptionTax = "";
    let cRoundingOffCl = "";
    let cWithholdingObjectCl = "";
    let cDutyFreeFG = "";
    let cAuthorTekikakuNo = "";

    // 支払先セット
    let obj = await getAPI("ms_author/" + cAuthorCd);
    if (obj) {
      cAuthorCd = nvl(obj.author_cd);
      cPennameNm = nvl(obj.penname_nm);
      cAuthorTel = nvl(obj.author_tel);
      cAuthorCellPhoneNo = nvl(obj.author_cell_phone_no);
      cAuthorAddr = nvl(obj.author_zipcode) + " " + nvl(obj.author_address_1) + nvl(obj.author_address_2) + nvl(obj.author_address_3);
      cAuthorAddrSend = nvl(obj.zipcode_send1) + " " + nvl(obj.address1_send1) + nvl(obj.address1_send2) + nvl(obj.address1_send3);
      cAuthorTelSend = nvl(obj.tel_send1);
      cEmailAddressAuthor = nvl(obj.email_address_author);
      cCommorancyCl = nvl(obj.commorancy_cl);
      cConsumptionTax = obj.consumption_tax === 0 ? sysConsumptionTaxCl : nvl(obj.consumption_tax);
      cRoundingOffCl = obj.rounding_off_cl === 0 ? sysRoundingOffCl : nvl(obj.rounding_off_cl);
      cWithholdingObjectCl = nvl(obj.withholding_object_cl);
      cDutyFreeFG = nvl(obj.duty_free);
      cAuthorTekikakuNo = nvl(obj.author_tekikaku_no);

      // 口座情報セット
      cBankAccountNm = nvl(obj.bank_account_nm);
      searchCondition = {
        bank_cd: obj.bank_cd,
        bank_branch_cd: obj.bank_branch_cd
      }
      let oBank = await getAPI("ms_bank", searchCondition);
      if (oBank.count === 1) {
        let o = oBank.results[0];
        cBankAccount = "";
        cBankAccount += nvl(o.bank_nm);
        cBankAccount += "(" + nvl(o.bank_cd) + ")";
        cBankAccount += "　";
        cBankAccount += nvl(o.bank_branch_nm);
        cBankAccount += "(" + nvl(o.bank_branch_cd) + ")";
        cBankAccount += "　";
        if (obj.kind_of_account_cl === "0") {
          cBankAccount += "普通";
        } else if (obj.kind_of_account_cd === "1") {
          cBankAccount += "当座";
        } else if (obj.kind_of_account_cd === "9") {
          cBankAccount += "総合";
        }
        cBankAccount += "　";
        cBankAccount += nvl(obj.bank_account_no);
      }
    }
    setAuthorCd(cAuthorCd);
    setPennameNm(cPennameNm);
    setAuthorTel(cAuthorTel);
    setAuthorCellPhoneNo(cAuthorCellPhoneNo);
    setAuthorAddr(cAuthorAddr);
    setAuthorAddrSend(cAuthorAddrSend);
    setAuthorTelSend(cAuthorTelSend);
    setEmailAddressAuthor(cEmailAddressAuthor);
    setDutyFreeFG(cDutyFreeFG);
    setAuthorTekikakuNo(cAuthorTekikakuNo);
    setBankAccountNm(cBankAccountNm);
    setBankAccount(cBankAccount);
    setCommorancyCl(cCommorancyCl);
    setConsumptionTax(cConsumptionTax);
    setRoundingOffCl(cRoundingOffCl);
    setWithholdingObjectCl(cWithholdingObjectCl);
    await onKeyDownNext();
  }

  const onSearchAuthor = async (query) => {
    let searchCondition = {
      search_word: query,
      pay_grp_type: "経費"
    };
    let res = await getAPI("ms_author_search_view", searchCondition);
    let options = [{
      option: rpad("ID", 7, ' ') + rpad("名", 20, ' ') + rpad("ペンネーム", 20, ' ') + "住所",
      id: "",
      name: "",
      penname_nm: "",
      isHeader: true
    }];
    res.results.map((obj) => (
      options.push({
        option:
          nvl(obj.author_cd) + " " +
          rpad(nvl(obj.customer_nm), 20, ' ') +
          rpad(nvl(obj.penname_nm), 20, ' ') +
          (nvl(obj.author_address_1) + nvl(obj.author_address_2) + nvl(obj.author_address_3)).trim(),
        id: obj.author_cd,
        name: nvl(obj.author_cd) + " " + nvl(obj.customer_nm),
        penname_nm: nvl(obj.penname_nm)
      })));
    return options;
  }

  // 合計集計
  const calcTotal = async () => {
    let cLineList = [];
    lineListRef.current.map(lineList => {
      if (lineList.current.getStates().index == null) {
        return undefined;
      }
      cLineList.push(lineList.current.getStates());
    });
    // 集計
    let cSubAmount = 0;
    let cSubAmount08 = 0;
    let cSubAmount10 = 0;
    let cSubAmountExempt = 0;
    let cSubAmountNonTax = 0;
    let cTaxAmount = 0;
    let cTaxAmount08 = 0;
    let cTaxAmount10 = 0;
    let cTotalAmount = 0;
    let cWithholdTaxAmount = 0;
    let cPayAmount = 0;
    for (let i = 0; i < cLineList.length; i++) {
      cSubAmount += cLineList[i].line_amount ? cLineList[i].line_amount : 0;
      cTaxAmount += cLineList[i].line_tax_amount ? cLineList[i].line_tax_amount : 0;
      cTotalAmount += cLineList[i].line_total_amount ? cLineList[i].line_total_amount : 0;
      cWithholdTaxAmount += cLineList[i].line_withhold_tax_amount ? cLineList[i].line_withhold_tax_amount : 0;
      cPayAmount += cLineList[i].line_pay_amount ? cLineList[i].line_pay_amount : 0;

      if (cLineList[i].line_tax_class_cd === CONST_TAX_EXP_10 || cLineList[i].line_tax_class_cd === CONST_TAX_INC_10) {
        cSubAmount10 += cLineList[i].line_total_amount ? cLineList[i].line_total_amount : 0;
        cTaxAmount10 += cLineList[i].line_tax_amount ? cLineList[i].line_tax_amount : 0;
      } else if (cLineList[i].line_tax_class_cd === CONST_TAX_EXP_08 || cLineList[i].line_tax_class_cd === CONST_TAX_INC_08) {
        cSubAmount08 += cLineList[i].line_total_amount ? cLineList[i].line_total_amount : 0;
        cTaxAmount08 += cLineList[i].line_tax_amount ? cLineList[i].line_tax_amount : 0;
      } else if (cLineList[i].line_tax_class_cd === CONST_TAX_EXEMPT) {
        cSubAmountExempt += cLineList[i].line_total_amount ? cLineList[i].line_total_amount : 0;
      } else if (cLineList[i].line_tax_class_cd === CONST_TAX_NON_TAX) {
        cSubAmountNonTax += cLineList[i].line_total_amount ? cLineList[i].line_total_amount : 0;
      }
    }
    setSubAmount(cSubAmount);
    setSubAmount08(cSubAmount08);
    setSubAmount10(cSubAmount10);
    setSubAmountExempt(cSubAmountExempt);
    setSubAmountNonTax(cSubAmountNonTax);
    setTaxAmount(cTaxAmount);
    setTaxAmount08(cTaxAmount08);
    setTaxAmount10(cTaxAmount10);
    setTotalAmount(cTotalAmount);
    setWithholdTaxAmount(cWithholdTaxAmount);
    setPayAmount(cPayAmount);
  }

  const onClickDownload = async () => {

    startLoadingBtn("btn-download", "secondary");

    let condition = {};
    addField(condition, "exp_id", expId);
    await downloadAPI("download/exp_dtl", condition);
    finishLoadingBtn("btn-download");
  }

  // グループダイアログ //////////////////////////////////////////////////////////////////////////
  const onClickShowPayGrpModal = async () => {
    setPayGrpModalShow(true);
  }

  const onClickClosePayGrpModal = async () => {
    setPayGrpModalShow(false);
  }

  // 基準日ダイアログ ///////////////////////////////////////////////////////////////////////////
  const onClickShowPayDateModal = async () => {
    setModalPayDateShow(true);
  }

  const onClickCloseModalPayDate = async () => {
    setModalPayDateShow(false);
  }

  const onClickSelectPayDate = async (pPayDate) => {
    setPayDate(pPayDate);
    setModalPayDateShow(false);
  }

  // 確認ダイアログ //////////////////////////////////////////////////////////////////////////
  const onClickShowConfirmModal = async () => {
    setConfirmModalShow(true);
  }

  const onClickCloseConfirmModal = async () => {
    setConfirmModalShow(false);
  }

  const onClickDelete = async () => {
    // ヘッダのみ論理削除（明細は物理削除しない。BAPAYDTの削除フラグはサーバ側で処理）
    await deleteAPI("tr_exp/" + expId + "/", { delete_pg: "ExpDtl" });
    setConfirmModalShow(false);
    success("取消が完了しました");
    history.push(RoutePaths.root.exp_list);
  }

  // 承認ダイアログ //////////////////////////////////////////////////////////////////////////
  const onClickShowAppModal = async () => {
    setAppModalShow(true);
  }

  const onClickCloseAppModal = async () => {
    setAppModalShow(false);
  }

  const onClickApprove = async () => {

    let obj = null;
    let res = null;
    let cNewStatus = nextStatusByApprove(status);

    // // 支払明細トランへの書込み
    // if(status === "経理承認中"){
    //   obj = {};
    //   obj.exp_id = expId;
    //   res = await postAPI("if_pay_dtl_tran_custom_view", obj);
    // }

    //経費の更新
    obj = {};
    obj.status = cNewStatus
    await patchAPI("tr_exp/" + expId + "/", obj);

    //支払ステータスの更新
    if (status === "支払前") {
      let condition = {
        pay_date: dateformatDB(payDate),
        pay_grp_num: payGrpNum,
        status0: true,
        status00: true,
        status01: true,
        status10: true,
        status20: true,
        status30: true
      };
      res = await getAPI("tr_exp_search_view", condition);
      if (res.count === 0) {
        condition = {
          pay_date: dateformatDB(payDate),
          pay_grp_type: "経費",
          pay_grp_num: payGrpNum,
          selected: true
        }
        res = await getAPI("ms_pay_grp_search_view", condition);
        if (res.count === 1) {
          obj = res.results[0];
          obj.status = "支払済";
          obj = await putAPI("ms_pay_grp/" + obj.pay_grp_id + "/", obj);
        }
      }
    }

    setStatus(cNewStatus);
    setAppModalShow(false);
    success("ステータスを更新しました");
  }

  const onClickReject = async () => {
  }

  return (
    <div>
      {/*内訳一覧*/}
      <div className="body-dtl body-dtl-const">
        <AppNav />
        <div id="exp-dtl-head"
          style={{ maxWidth: "1800px", margin: "0 auto" }}
        >
          <Row className="h1">
            <Col sm="3">
              <h1>
                支払内訳
              </h1>
            </Col>
            <Col sm="9" className="text-right">
              <Button as={Link} to={RoutePaths.root.exp_list} variant="quaternary" className="mr-4">
                戻る
              </Button>
              <Button variant="tertiary" className="mr-4" onClick={e => onClickShowConfirmModal()} disabled={!status || status === "支払済"}>
                取消
              </Button>
            </Col>
          </Row>
          <Container className="container-main-detail-header"
            onKeyDown={(e) => onKeyDownShortCut(e, null, () => onKeyDownCtlEnter(e), () => onKeyDownEsc(e), () => onKeyDownSpace(e), () => onKeyDownEnter(e))}
          >
            <Form.Group as={Row} style={{ marginRight: "-15px", marginLeft: "-15px" }}>
              <Form.Label column sm="1" style={{ borderTop: "solid 1px #e3e5e9" }}>
                処理日
              </Form.Label>
              <Col sm="2" className="input-group p-0 input-col" style={{ borderTop: "solid 1px #e3e5e9" }}>
                <div className="input-group">
                  <Form.Control
                    id="expDate"
                    type="text"
                    className="text-center"
                    tabIndex={10}
                    value={expDate}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setExpDate(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setExpDate(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                    autoFocus={true}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalExpDate(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar} />
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(expDate))}
                  onChange={handleChangeCalExpDate}
                  open={openCalExpDate}
                  onClickOutside={e => setOpenCalExpDate(false)}
                  customInput={<div style={{ display: "none" }} />}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
              <Form.Label column sm="1" style={{ borderTop: "solid 1px #e3e5e9" }}>
                支払日
              </Form.Label>
              <Col sm="2" className="input-group p-0 input-col" style={{ borderTop: "solid 1px #e3e5e9" }}>
                <div className="input-group">
                  <Form.Control
                    id="payDate"
                    type="text"
                    className="text-center"
                    tabIndex={11}
                    value={payDate}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setPayDate(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setPayDate(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalPayDate(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar} />
                  </button>
                </div>
                <DatePicker
                  wrapperClassName="display-none-date-wrapper"
                  selected={dateformatDatePicker(toSingleByteNumberOnly(payDate))}
                  onChange={handleChangeCalPayDate}
                  open={openCalPayDate}
                  onClickOutside={e => setOpenCalPayDate(false)}
                  customInput={<div style={{ display: "none" }} />}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
              <Form.Label column sm="1" style={{ borderTop: "solid 1px #e3e5e9" }}>
                Gno
              </Form.Label>
              <Col sm="1" className="input-group p-0 input-col" style={{ borderTop: "solid 1px #e3e5e9" }}>
                <Form.Control
                  type="text"
                  tabIndex={12}
                  inputMode="numeric"
                  style={{ borderRadius: "0", textAlign: "center" }}
                  value={payGrpNum}
                  onKeyPress={e => {
                    checkKey(e, /[0-9\-]/);
                    onKeyDownNext(e);
                  }}
                  onFocus={e => onFocusText(e)}
                  onChange={e => setPayGrpNum(e.target.value)} />
              </Col>

              <Form.Label column sm="1" style={{ borderTop: "solid 1px #e3e5e9" }}>
                ステータス
              </Form.Label>
              <Col sm="3" style={{ borderTop: "solid 1px #e3e5e9", paddingTop: "4px" }}>
                <div className={
                  !status ? 'tag-status status-0 text-center' :
                    status === '新規' ? 'tag-status status-00 text-center' :
                      status === '支払前' ? 'tag-status status-01 text-center' :
                        status === '副社長承認中' ? 'tag-status status-10 text-center' :
                          status === '社長承認中' ? 'tag-status status-20 text-center' :
                            status === '処理中' ? 'tag-status status-30 text-center' :
                              status === '支払済' ? 'tag-status status-90 text-center' :
                                'd-inline-block'
                }
                  style={{ width: "130px" }}
                >
                  {status ? status : "未作成"}
                </div>
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{ borderLeft: "solid 1px #e3e5e9", marginRight: "-15px", marginLeft: "-15px" }}>
              <Form.Label column sm="1">
                支払先
              </Form.Label>
              <Col sm="5" className="p-0">
                <AsyncSelect
                  tabIndex={13}
                  className="async-select async-select-author"
                  classNamePrefix="async-select"
                  styles={asyncSelectStyles}
                  components={{ DropdownIndicator: null }}
                  cacheOptions
                  isOptionDisabled={(option) => option.isHeader === true}
                  value={authorSelected}
                  onMenuOpen={e => setSelectMenuOpen(true)}
                  onMenuClose={e => setSelectMenuOpen(false)}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      e.stopPropagation(); // 親ContainerのonKeyDownEnterへのバブリングを防ぐ
                      if (!selectMenuOpen) {
                        setTimeout(() => {
                          onKeyDownNext(e);
                        }, 100); // バグ対応：遅延させることでカーソル表示
                      }
                    } else if (!selectMenuOpen) {
                      setTimeout(() => {
                        onKeyDownNext(e);
                      }, 100); // バグ対応：遅延させることでカーソル表示
                    }
                  }}
                  getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.option}`}
                  getOptionValue={e => e.id}
                  loadOptions={onSearchAuthor}
                  onChange={handleChangeAuthor}
                  placeholder="支払先を検索する。　例：会社名、氏名、ペンネームなど"
                />
              </Col>
              <Form.Label column sm="1">
                登録番号
              </Form.Label>
              <Col sm="2" className="d-flex justify-content-center align-items-center">
                {dutyFreeFG === 1 &&
                  <span>
                    免税事業者
                  </span>
                }
                {dutyFreeFG === 0 &&
                  <Form.Control plaintext readOnly tabIndex={-1} value={authorTekikakuNo} />
                }
              </Col>
              <Form.Label column sm="1">
                携帯
              </Form.Label>
              <Col sm="2" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={authorCellPhoneNo} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{ borderLeft: "solid 1px #e3e5e9", marginRight: "-15px", marginLeft: "-15px" }}>
              <Form.Label column sm="1">
                住所
              </Form.Label>
              <Col sm="8" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={authorAddr} />
              </Col>
              <Form.Label column sm="1">
                電話 自宅
              </Form.Label>
              <Col sm="2" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={authorTel} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} style={{ borderLeft: "solid 1px #e3e5e9", marginRight: "-15px", marginLeft: "-15px" }}>
              <Form.Label column sm="1">
                勤務先
              </Form.Label>
              <Col sm="8" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={authorAddrSend} />
              </Col>
              <Form.Label column sm="1">
                電話 勤務先
              </Form.Label>
              <Col sm="2" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={authorTelSend} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-1" style={{ borderLeft: "solid 1px #e3e5e9", marginRight: "-15px", marginLeft: "-15px" }}>
              <Form.Label column sm="1">
                口座名義
              </Form.Label>
              <Col sm="2" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={bankAccountNm} />
              </Col>
              <Form.Label column sm="1">
                口座
              </Form.Label>
              <Col sm="5" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={bankAccount} />
              </Col>
              <Form.Label column sm="1">
                メール
              </Form.Label>
              <Col sm="2" className="input-group">
                <Form.Control plaintext readOnly tabIndex={-1} value={emailAddressAuthor} />
              </Col>
            </Form.Group>
          </Container>
          <Container id="exp-dtl-list" className="container-main-detail-list pb-2">
            <div className="d-flex flex-row mt-1" style={{ marginLeft: "-5px", marginRight: "-15px" }}>
              <div className="container" style={{ flex: "85 1 0%", padding: "0" }}>
                <Row>
                  <Col lg={5}>
                    <Row className="tbl-h-00">
                      <Col lg="1" className="tbl-h-00-top tbl-h-00-start">No.</Col>
                      <Col lg="3" className="tbl-h-00-top">科目</Col>
                      <Col lg="4" className="tbl-h-00-top">補助科目</Col>
                      <Col lg="4" className="tbl-h-00-top">カテゴリ</Col>
                    </Row>
                  </Col>
                  <Col lg={7}>
                    <Row className="tbl-h-00">
                      <Col lg="2" className="tbl-h-00-top">税区</Col>
                      <Col lg="2" className="tbl-h-00-top">金額</Col>
                      <Col lg="2" className="tbl-h-00-top">消費税</Col>
                      <Col lg="2" className="tbl-h-00-top">税込合計</Col>
                      <Col lg="2" className="tbl-h-00-top">源泉所得税</Col>
                      <Col lg="2" className="tbl-h-00-top">支払金額</Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col lg={5}>
                    <Row className="tbl-h-00">
                      <Col lg="8" className="tbl-h-00-start" style={{ borderBottom: "solid 1px #AAAAAA" }}>書名</Col>
                      <Col lg="4" style={{ borderBottom: "solid 1px #AAAAAA" }}>部門</Col>
                    </Row>
                  </Col>
                  <Col lg={7}>
                    <Row className="tbl-h-00">
                      <Col lg="2" style={{ borderBottom: "solid 1px #AAAAAA" }}>企画コード</Col>
                      <Col lg="10" style={{ borderBottom: "solid 1px #AAAAAA" }}>摘要</Col>
                    </Row>
                  </Col>
                </Row>
                {lineList.filter((line) => 1 === 1).map((obj, index) => (
                  <ExpDtlLine key={index}
                    ref={lineListRef.current[index]}
                    index={index}
                    line={obj}
                    accList={accList}
                    expenseList={expenseList}
                    remarkList={remarkList}
                    deptList={deptList}
                    itemList={itemList}
                    dutyFreeFG={dutyFreeFG}
                    taxRate={taxRate}
                    commorancyCl={commorancyCl}
                    consumptionTax={consumptionTax}
                    roundingOffCl={roundingOffCl}
                    withholdingObjectCl={withholdingObjectCl}
                    appendLine={appendLine}
                    onFocusAcc={onFocusAcc}
                    calcTotal={calcTotal}
                    onClickExpSave={onClickExpSave}
                    onKeyDownEsc={onKeyDownEsc}
                  />
                ))}
                <Row className="pt-1">
                  <Col lg={5}>
                  </Col>
                  <Col lg={7}>
                    <Row className="tbl-b-00" style={{ borderLeft: "solid 1px #e3e5e9", borderTop: "solid 1px #e3e5e9" }}>
                      <Form.Label column lg="2" className="text-center">合計</Form.Label>
                      <Col sm="2" className="input-group form-group">
                        <Form.Control className="col-num" plaintext readOnly value={formatNumber(subAmount)} />
                      </Col>
                      <Col sm="2" className="input-group form-group">
                        <Form.Control className="col-num" plaintext readOnly value={formatNumber(taxAmount)} />
                      </Col>
                      <Col sm="2" className="input-group form-group">
                        <Form.Control className="col-num" plaintext readOnly value={formatNumber(totalAmount)} />
                      </Col>
                      <Col sm="2" className="input-group form-group">
                        <Form.Control className="col-num" plaintext readOnly value={formatNumber(withholdTaxAmount)} />
                      </Col>
                      <Col sm="2" className="input-group form-group">
                        <Form.Control className="col-num" plaintext readOnly value={formatNumber(payAmount)} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div className="pt-1 d-flex justify-content-end" style={{ marginRight: "-15px", marginLeft: "-15px" }}>
                  <Button variant="primary" onClick={e => onClickExpSave()} disabled={status === "支払済"}>
                    保存
                  </Button>
                </div>
              </div>
              <div className="container" style={{ flex: "15 1 0%" }}>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start tbl-h-00-top" style={{ borderBottom: "1px solid #E3E5E9" }}>金額10%</Col>
                  <Col lg="6" className="col-num tbl-h-00-top" style={{ padding: ".375rem", borderBottom: "1px solid #FFFFFF" }}>{amountFormatter(subAmount10)}&nbsp;</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start" style={{ borderTop: "1px solid #E3E5E9" }}></Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>({amountFormatter(taxAmount10)})</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start" style={{ borderBottom: "1px solid #E3E5E9" }}>金額&nbsp;8%</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem", borderBottom: "1px solid #FFFFFF" }}>{amountFormatter(subAmount08)}&nbsp;</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start" style={{ borderTop: "1px solid #E3E5E9" }}></Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>({amountFormatter(taxAmount08)})</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">非課税</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(subAmountExempt)}&nbsp;</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">不課税</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(subAmountNonTax)}&nbsp;</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">合計金額</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(totalAmount)}&nbsp;</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">源泉金額</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(withholdTaxAmount)}&nbsp;</Col>
                </Row>
                <Row className="ml-1 tbl-b-00">
                  <Col lg="6" className="tbl-h-00 tbl-h-00-start">支払金額</Col>
                  <Col lg="6" className="col-num" style={{ padding: ".375rem" }}>{amountFormatter(payAmount)}&nbsp;</Col>
                </Row>
              </div>
            </div>
          </Container>
        </div>
      </div>

      {/*基準日選択ダイアログ*/}
      <Modal id="schedule-pay-date-dialog" show={modalPayDateShow} onHide={onClickCloseModalPayDate} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>基準日選択</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PayDateDialog
            pPayDate={payDate}
            pOnClickSelectPayDate={onClickSelectPayDate}
          />
        </Modal.Body>
      </Modal>

      {/*支払ステータスダイアログ*/}
      <Modal id="pay-group-dialog" show={payGrpModalShow} onHide={onClickClosePayGrpModal} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>支払ステータス</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PayGrpList pIsModal={true} pPayGrpType="経費" pPayDate={parseDate(payDate)} setPayGrpNum={setPayGrpNum} setPayGrpModalShow={setPayGrpModalShow} />
        </Modal.Body>
      </Modal>

      {/*承認ダイアログ*/}
      <Modal id="approval-dtl-dialog" show={appModalShow} onHide={onClickCloseAppModal} animation={false} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>承認</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="card-search">
            <ApproveList
              pPayId={null}
              pExpId={expId}
              pStatus={status}
              pOnClickApprove={onClickApprove}
              pOnClickReject={onClickReject}
            />
          </Card>
        </Modal.Body>
      </Modal>

      {/*確認ダイアログ*/}
      <Modal id="confirm-modal" show={confirmModalShow} onHide={onClickCloseConfirmModal} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>取消確認</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          この経費の支払いを取消してよいですか
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button variant="secondary" onClick={onClickCloseConfirmModal}>
            いいえ
          </Button>
          <Button variant="danger" onClick={onClickDelete}>
            はい
          </Button>
        </Modal.Footer>
      </Modal>

      {/*ポップアップメッセージ*/}
      <Toast />
    </div>
  )
    ;
}

export default withRouter(ExpDtl);